<script setup>
import AlertTable from '@frontJs/components/tables/projectManagement/alerts/AlertTable.vue';
import TenantReportAlertTable from '@frontJs/components/tables/projectManagement/alerts/tenantReports/AlertTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Alertes - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Alertes </PageTitle>

    <AlertTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                contentSlotName: 'all',
            },
            perCustomer: {
                title: 'Par client',
                contentSlotName: 'perCustomer',
            },
        }"
    >
        <template #all>
            <AlertTable all />
        </template>

        <template #perCustomer>
            <TenantReportAlertTable />
        </template>
    </TabLayout>
</template>
